import util from '@bmp-vue/core/api/util'

const controller = 'SLC0005'
export default Object.assign({}, util.GetCrud(controller, null), {
  Get (dto) {
    return util.Axios.GetAll(controller + '/Get', dto)
  },
  AlterarConciliado (dto) {
    return util.Axios.Post(controller + '/AlterarConciliado', dto)
  }
})
